'use strict';

module Patersons {

  export class TokenService {
    oauthSettings: Oidc.OidcTokenManagerSettings;
    tokenManager: Oidc.OidcTokenManager;

    constructor() {
      var model: string = document.getElementById("model").textContent.trim();
      var dictionary: any = JSON.parse(model);

      this.oauthSettings = dictionary['oauthSettings'];
      this.tokenManager = new OidcTokenManager(this.oauthSettings);
    }
  }
}
